"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MapMarker = void 0;
var _react = _interopRequireDefault(require("react"));
var _api = require("@react-google-maps/api");
/** A map marker component. */
var MapMarker = function MapMarker(_ref) {
  var label = _ref.label,
    position = _ref.position,
    onClick = _ref.onClick,
    icon = _ref.icon,
    open = _ref.open,
    onClose = _ref.onClose,
    children = _ref.children,
    dataTestId = _ref['data-testid'];
  return (
    /*#__PURE__*/
    /* @ts-ignore: react types version issues */
    _react["default"].createElement(_api.Marker, {
      label: label,
      position: position,
      onClick: onClick,
      icon: icon,
      "data-testid": dataTestId
    }, open &&
    /*#__PURE__*/
    /* @ts-ignore: react types version issues */
    _react["default"].createElement(_api.InfoWindow, {
      onCloseClick: onClose,
      position: position
    }, children))
  );
};
exports.MapMarker = MapMarker;